<template lang="pug">
.app--footer
  .app--footer-main
    .app--footer-content.content-container
      .links-container
        .label 友情链接Link
        .links
          a.link(v-for="link in links" :key="link.id" :href="link.url" target="_blank") {{ link.title }}
      .info-container
        .logo-container
          img(src="@/assets/logo.png")
        .contract-container
          .contract-divider
          .contract-group
            .contract-items
              .contract-item
                .label 电话TEL：
                .value {{ contractInfo.tel }}
              .contract-item
                .label 邮箱EMAIL：
                .value {{ contractInfo.email }}
          .contract-divider
          .contract-group
            .contract-items
              .contract-item
                .label 传真FOX：
                .value {{ contractInfo.fox }}
              .contract-item
                .label 地址ADD：
                .value {{ contractInfo.add }}
          .contract-divider
        .wechat-container
          img.qrcode
          .label
            .label-cn 微信公众号
            .label-en WeChat
  .app--footer-copyright
    .app--footer-content.content-container
      | © 2017  陆良农业  http://www.llshc.com/  版权所有.&emsp;
      a(href="https://beian.miit.gov.cn/") 云ICP备09083614号-40
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AppFooter",
  data() {
    return {
      links: [],
      contractInfo: {
        tel: '0874-6262333',
        email: '9674442@qq.com',
        fox: '0874-6262333',
        add: '陆良县爨乡路196号',
      }
    }
  },
  methods: {
    ...mapActions({
      queryLinks: 'platform/queryLinks',
    }),
    async loadLinks() {
      const {data} = await this.queryLinks();
      this.links = [...data.list];
    },
  },
  created() {
    this.loadLinks();
  }
}
</script>

<style lang="scss" scoped>
.app--footer{
  background: rgba(217, 221, 224, 0.47);
  .app--footer-main{
    padding: 20px 0 36px;
    .links-container{
      display: flex;
      align-items: flex-start;
      .label{
        font-weight: 700;
        font-size: 12px;
        color: #202948;
        line-height: 36px;
      }
      .links{
        display: flex;
        flex-wrap: wrap;
        padding-left: 12px;
        .link{
          font-size: 12px;
          height: 36px;
          line-height: 36px;
          padding: 0 10px;
          background-color: white;
          border-radius: 4px;
          color: $title_color;
          cursor: pointer;
          text-decoration: none;
          & + .link{
            margin-left: 8px;
          }
        }
      }
    }
    .info-container{
      display: flex;
      align-items: center;
      padding-top: 36px;
      .contract-container{
        flex: 1;
        display: flex;
        justify-content: space-around;
        height: 52px;
        .contract-group{
          flex: 1;
          display: flex;
          justify-content: center;
          .contract-items{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .contract-item{
            display: flex;
            font-weight: 700;
            font-size: 14px;
            color: #202948;
          }
        }
        .contract-divider{
          @include size(1px, 100%);
          background-color: rgba(153, 153, 153, 0.2);
          margin: 0 40px;
        }
      }
      .wechat-container{
        display: flex;
        align-items: center;
        .qrcode{
          @include square(108px);
          background-color: white;
        }
        .label{
          padding-left: 16px;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: #202948;
        }
      }
    }
  }
  .app--footer-copyright{
    height: 36px;
    background: rgba(255, 255, 255, 1);
    font-size: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    a{
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
